import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './app'

if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		navigator.serviceWorker.register('/sw.js')
			.then((registration) => {
				console.log('[PWA] Service Worker registered successfully:', registration.scope)
			})
			.catch((error) => {
				console.error('[PWA] Service Worker registration failed:', error)
			})
	})

	// Handle messages from service worker
	navigator.serviceWorker.addEventListener('message', (event) => {
		if (event.data?.type === 'GET_CURRENT_PATH') {
			event.ports[0].postMessage({ pathname: window.location.pathname })
		} else if (event.data?.type === 'NAVIGATE_TO') {
			window.location.href = event.data.url
		}
	})
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<React.StrictMode>
		<BrowserRouter>
			<App />	
		</BrowserRouter>
	</React.StrictMode>,
)
